export default __webpack_public_path__ + "static/media/kart.8cce93cf.png";